import { useRef } from 'react';

export function useRequestAnimationFrame<Args extends Array<unknown>>(
  fn: (...args: Args) => void,
) {
  const requestId = useRef<number | null>(null);
  const pendingArguments = useRef<Args | null>(null);

  const debounced = (...args: Args): void => {
    if (!requestId.current) {
      requestId.current = requestAnimationFrame(() => {
        try {
          fn(...(pendingArguments.current ?? args));
        } catch (e) {
          console.error(e);
        } finally {
          requestId.current = null;
          pendingArguments.current = null;
        }
      });
    } else {
      pendingArguments.current = args;
    }
  };

  return debounced;
}
